// extracted by mini-css-extract-plugin
module.exports = {"richTextWrapper":"RichText_richTextWrapper__lUMUb"};